import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { SidebarCategoryItem } from './SidebarCategoryTypes';

interface Props {
    item: SidebarCategoryItem;
}

const LeftSidebarCategoryItem = ({ item }: Props) => {
    const location = useLocation();

    const isSelected = location.pathname.startsWith(item.path);

    return (
        <li className={`sidebar-item ${isSelected ? 'selected' : ''}`} onClick={item.clickCallback}>
            <Link className="sidebar-link" to={item.path}>
                <i className={`mdi ${item.icon}`} />
                <span className="hide-menu">{item.name}</span>
            </Link>
        </li>
    );
};

export default LeftSidebarCategoryItem;
